import { ComponentProps } from 'react';
import cx from 'classnames';

import styles from './LengthCounter.module.scss';

interface LengthCounterProps extends ComponentProps<'div'> {
  length: number;
  maxLength: number;
}

export const LengthCounter = ({
  className,
  length = 0,
  maxLength,
  ...rest
}: LengthCounterProps) => {
  const isError = length > maxLength;

  return (
    <div
      className={cx(styles.counter, isError && styles.error, className)}
      {...rest}
    >
      {length}/{maxLength}
    </div>
  );
};
